export class Listas {
    lista: string;
    id: number;
    codigo: string;
    descripcion: string;
    dependenciaCodigo: string;
    dependienciaId: number;
    condicionString1: string;
    condicionString2: string;
    condicionLogica1: boolean;
    condicionLogica2: boolean;
    condicionEntero1: number;
    condicionEntero2: number;
    condicionEntero3: number;
    condicionEntero4: number;
    condicionFloat1: number;
    condicionFloat2: number;
}